<template>
  <div v-if="ifCVbase" class="dashboard-section">
    <div class="dashboard-section-header">
      <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Cvthèque active</div>
      <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
    </div>
    <div class="dashboard-section-content">
      <div class="dashboard-section-content-italic">
        Vous avez autorisé la diffusion de votre profil sur notre cvthèque :
      </div>
      <div class="dashboard-section-content-space"/>
      <div class="dashboard-section-content-italic">
        Des vétérinaires peuvent vous contacter pour des entretiens d'embauche.
      </div>
      <div class="dashboard-section-content-space"/>
      <div class="dashboard-section-content-italic">
        Vérifiez les informations de votre dossier afin d'améliorer votre visibilité auprès des employeurs vétérinaires.
      </div>
      <div class="dashboard-section-content-space"/>
      <div class="dashboard-section-content-italic">
        Depuis l'onglet "DOSSIER", mettez à jour votre photo, votre CV, votre lettre de motivation, vos derniers stages professionnels, etc.
      </div>
      <div class="dashboard-section-content-space"/>
      <div class="dashboard-section-content-italic">
        Ce dossier en ligne ne vous dispense pas de rechercher activement un employeur.
      </div>
    </div>
  </div>
  <div v-else class="dashboard-section dashboard-section--warning">
    <div class="dashboard-section-header">
      <div class="dashboard-section-header-title dashboard-section-header-title--warning"><img src="@/assets/img/raster.png">Cvthèque non-active !</div>
      <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_warning.png"></div>
    </div>
    <div class="dashboard-section-content">
      <div class="dashboard-section-content-italic">
        Vous n'avez pas autorisé la diffusion de votre profil sur notre cvthèque : les vétérinaires désireux de recruter un alternant ASV ne peuvent pas vous contacter pour des entretiens d'embauche.
      </div>
      <div class="dashboard-section-content-space"/>
      <div class="dashboard-section-content-italic">
        Vérifiez les informations de votre dossier afin d'améliorer votre visibilité auprès des employeurs vétérinaires.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CVBase",
  props: {
    ifCVbase: Boolean
  },
};
</script>
